import React, { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import useAxios from 'hooks/useAxios';

const NDCLISTINPUT = ({
  tenantID,
  selectedProvider,
  onSelect,
  isMulti = false,
  selectedRow,
  acid
}) => {
 
  const API = useAxios();
  const [providerName, setProviderName] = useState('');
  const [providerOpt, setProviderOpt] = useState([]);
  const [providerLoading, setProviderLoading] = useState(false);

  useEffect(() => {
    if (providerOpt.length && !selectedProvider) {
      setProviderOpt([]);
    }
  }, [selectedProvider]);

  const handleChangeProvider = async (value) => {
    setProviderName(value);
   // if (!tenantID || !value) return null;

    if (value && value.length < 3) {
      if (providerOpt.length) {
        setProviderOpt([]);
      }
      return null;
    }

    setProviderLoading(true);
    try {
      const result = await API.get(
        `SBConfig/AutoSearch/NdcListCRW/${value}`,
        { hasDefaultURL: true, }
      );
      if (result?.data?.length > 0) {
       // onSelectProvider({code: value,description: ""})
        setProviderOpt(result.data);
        setProviderLoading(false);
      } else {
       // onSelectProvider({code: value,description: ""})
        setProviderOpt([]);
        setProviderLoading(false);
      }
    } catch (error) {
      setProviderLoading(false);
    }
  };

  const onSelectProvider = (provider) => {
    debugger;
    onSelect(provider);
  };

  return (
    <Select
      className='form-field-large inner-shadow-field required '
      classNamePrefix='select'
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={providerLoading}
     placeholder='Enter any 3 characters'
      name='color'
 
      // isDisabled={selectedRow == undefined ? false : (selectedRow.mapingStatus == "UnMappedChargeCode" || selectedRow.mapingStatus == "Active")}
      options={providerOpt}
      inputValue={providerName}
      value={selectedProvider}
      onInputChange={handleChangeProvider}
      onChange={onSelectProvider}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.code}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
          borderLeft: '4px solid $primary !important'
        }),
        
      }}
      isMulti={isMulti}
    />
  );
};

export default NDCLISTINPUT;
